import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { NexAlert } from "../../components/Alert/Alert"
import { StepperForm } from "../../components/StepperForm/StepperForm"
import { useTitle } from "../../hooks/useTitle"
import { LookupTableId, lookupTablesMap } from "../../models/LookupTable"
import { useLookupTableStore } from "../../zstore/LookupTableStore"
import { LookupTable } from "./LookupTable"
import { getLookupValidatorModel } from "./LookupValidatorModel"

export const LookupEditor = () => {
    const {
        selectedTableId,
        setSelectedTableId,
        isFetching,
        isSubmitting,
        rows,
        columns,
        primaryKey,
        fetchLookupTable,
        updateLookupTable,
        hasBeenEdited,
        reset,
        error,
    } = useLookupTableStore()
    const navigate = useNavigate()

    const currentTableLabel = lookupTablesMap.get(selectedTableId)
    useTitle(currentTableLabel ? `${currentTableLabel.label} - Lookup Table` : "Lookup Table")

    useEffect(() => {
        reset()
        fetchLookupTable(selectedTableId)
        return reset
    }, [])

    const handleStepChange = async (newStep: number) => {
        if (newStep === -1) {
            navigate(-1)
        } else {
            await updateLookupTable()
        }
    }

    return (
        <StepperForm
            loading={isFetching}
            submitting={isSubmitting}
            disableSubmit={!hasBeenEdited}
            header={
                <ToggleButtonGroup
                    sx={{ mb: 2 }}
                    value={selectedTableId}
                    exclusive={true}
                    disabled={isFetching || isSubmitting}
                    onChange={async (_: React.MouseEvent<HTMLElement>, newLookupTableId: LookupTableId | null) => {
                        if (newLookupTableId != null) {
                            setSelectedTableId(newLookupTableId)
                            await fetchLookupTable(newLookupTableId)
                        }
                    }}
                    aria-label="text alignment"
                >
                    {Array.from(lookupTablesMap).map((lookupValue) => (
                        <ToggleButton value={lookupValue[0]} aria-label={lookupValue[1].label} key={lookupValue[0]}>
                            {lookupValue[1].label}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            }
            validationProps={{
                dependencies: [rows],
                model: getLookupValidatorModel(rows, columns),
            }}
            onStepChange={handleStepChange}
        >
            {error && <NexAlert severity={"error"}>{error}</NexAlert>}
            {primaryKey && <LookupTable primaryKey={primaryKey} />}
        </StepperForm>
    )
}
